import { Link, useHistory } from "react-router-dom";
import { TranslationService } from "../../services/TranslationService";
import React, { useContext } from "react";
import CompanyService from "../../services/CompanyService";
import TabPositionContext from "./TabPositionContext";
import { CashappLayoutHeader } from "./layout/CashappLayoutHeader";
import FloatingPanelService from "./FloatingPanel";
import { NewCompany } from "./NewCompany";
import { Counter } from "../inbox/InboxTabContent";
import intizaLogoPng from "../../assets/img/intizaLogo.png";
import ModalService from "./bootstrap/Modal";
import { Message } from "./SupportButton";
import TooltipComponent from "./TooltipComponent";
import { AvatarUser } from "./components/AvatarUser";

const LayoutHeader: React.FC = () => {
    const { currentTabPosition, inboxCount } = useContext(TabPositionContext);
    const history = useHistory()

    const openTechnicalSupportModal = () => {
        ModalService.showDefaultModal({
            title: TranslationService.translate.ContactSupport,
            hideClose: true,
            size: 'modal-lg',
            message: Message
        });
    };

    return (<>
        <header>
            <nav className="navbar navbar-expand-sm bg-white">
                <div className="container-fluid d-flex flex-row flex-nowrap p-0">

                    <Link to={"/"}><img src={CompanyService.getCompanyAuth()?.logoUrl ?? intizaLogoPng} alt="Logo de Intiza" className="imgLogoControlWidth" /></Link>

                    <div className="navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-0">
                            <NavItem link="company" name={TranslationService.translate.Dashboard} />
                            <NavItem link="client" name={TranslationService.translate.Clients} />
                            <NavItem link="inbox" name={TranslationService.translate.Inbox} counter={inboxCount?.count} />
                            <NavItem link="task" name={TranslationService.translate.Tasks} />
                            <NavItem link="segment" name={TranslationService.translate.Segments} />
                            {(CompanyService.getIsAdmin() || CompanyService.getIsOwner()) && <NavItem link="action" name={TranslationService.translate.Automatic} />}
                            <CashappLayoutHeader />
                            {CompanyService.canDo("viewreport") &&
                                <li className={"nav-item dropdown" + (currentTabPosition === "Reports" ? " active" : "")}>
                                    <button className="btn nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <p>{TranslationService.translate.Reports} <i className="ms-2 fas fa-chevron-down"></i></p>
                                        <hr />
                                    </button>
                                    <div className="dropdown-menu">
                                        <ul>
                                            <DropdownTitle>{TranslationService.translate.DebtAnalysis}</DropdownTitle>
                                            <DropdownItem link="report/ReportReceivablesSummary" name={TranslationService.translate.CollectionAnalisis} />
                                            <DropdownItem link="report/collection" name={TranslationService.translate.RecoveryAnalysis} />
                                            <DropdownItem link="report/reportaginggroup" name={TranslationService.translate.AgingAnalysis} />
                                        </ul>
                                        <ul>
                                            <DropdownTitle>{TranslationService.translate.Clients}</DropdownTitle>
                                            <DropdownItem link="report/client" name={TranslationService.translate.CustomerAnalysis} />
                                            <DropdownItem link="report/persongroup" name={TranslationService.translate.ClientSummary} />
                                            <DropdownItem link="report/reportclientmap" name={TranslationService.translate.ClientsMap} />
                                            <DropdownItem link="report/credit" name={TranslationService.translate.CreditAnalysis} />
                                        </ul>
                                        <ul>
                                            <DropdownTitle>{TranslationService.translate.Invoices} {TranslationService.translate.And.toLocaleLowerCase()} {TranslationService.translate.Payments}</DropdownTitle>
                                            <DropdownItem link="report/iolist" name={TranslationService.translate.HeaderInvoices} />
                                            <DropdownItem link="report/invoicegroup" name={TranslationService.translate.InvoiceSummary} />
                                            {CompanyService.getSetting("messageiolink") &&
                                                <DropdownItem link="report/ioactivity" name={TranslationService.translate.ReportInvociesActivities} />}
                                            <DropdownItem link="report/payment" name={TranslationService.translate.Transaction} />
                                            <DropdownItem link="report/paymentgroup" name={TranslationService.translate.PaymentSummary} />
                                            <DropdownItem link="report/reportpaymentanalysis" name={TranslationService.translate.PaymentAnalysis} />
                                        </ul>
                                        <ul>
                                            <DropdownTitle>{TranslationService.translate.Activities}</DropdownTitle>
                                            <DropdownItem link="report/reportactivity" name={TranslationService.translate.Activities} />
                                            <DropdownItem link="report/reportactivitysummary" name={TranslationService.translate.ActivitySummary} />
                                            <DropdownItem link="report/activitytypesummary" name={TranslationService.translate.ActivitiesTypes} />
                                            {Boolean(CompanyService.getTags()?.length) && <DropdownItem link="report/taglist" name={TranslationService.translate.Tags} />}
                                        </ul>
                                        <ul>
                                            <DropdownTitle>{TranslationService.translate.Other}</DropdownTitle>
                                            <DropdownItem link="report/reportexport" name={TranslationService.translate.Templates} />
                                            <DropdownItem link="report/scheduled" name={TranslationService.translate.ScheduledReports} />
                                            {TranslationService.getCurrentLanguage() === "es" &&
                                                <DropdownItem link="report/log" name={"Registro"} />}
                                        </ul>
                                    </div>
                                </li>
                            }
                        </ul>
                        <div className="d-flex align-items-center">
                            <ul className="company-dropdown">
                                <li className="nav-item dropdown">
                                    <button className="btn nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <p>{CompanyService.getCompanyAuth()?.companyName}<i className="ms-2 fas fa-chevron-down"></i></p>
                                    </button>
                                    <div className="dropdown-menu">
                                        <ul>
                                            <li>
                                                <Link to={"#"} className="addCompany processMenuItem" href="#" onClick={() => history.push(`/${TranslationService.currentLanguage}/processlog`)}>
                                                    <h5>{TranslationService.translate.ProcessLog}</h5>
                                                </Link>
                                            </li>
                                            <li>
                                                {CompanyService.getCompanies().filter(x => x.Id !== CompanyService.getCompanyId()).map(x => <CompanyItem {...x} key={x.Id} />)}
                                            </li>
                                            {CompanyService.canDo("newcompany") && <li>
                                                <Link to={"#"} className="addCompany" href="#" onClick={() => FloatingPanelService.showPanel({
                                                    children: <NewCompany />,
                                                    title: TranslationService.translate.NewCompany,
                                                    height: 300,
                                                    width: 600,
                                                    position: "center",
                                                })}>
                                                    <h5><i className="fas fa-plus me-2"></i>{TranslationService.translate.AddCompany}</h5>
                                                </Link>
                                            </li>}
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                            <div className="d-flex align-items-center gap-3 mx-3">
                                <TooltipComponent title={TranslationService.translate.ContactSupport}>
                                    <i onClick={openTechnicalSupportModal} className="fal fa-question-circle menu-action-icon pointer "></i>
                                </TooltipComponent>
                                {(CompanyService.getIsAdmin() || CompanyService.getIsOwner()) &&
                                    <TooltipComponent title={TranslationService.translate.CompanySettings}>
                                        <i onClick={() => history.push(`/${TranslationService.currentLanguage}/edit`)} className="fal fa-cog menu-action-icon pointer"></i>
                                    </TooltipComponent>}
                                <AvatarUser />
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header >
    </>);
};

function getLinkTo(link: string) {
    return "/" + TranslationService.currentLanguage + "/" + link;
}

const NavItem = ({ link, name, counter }: { link: string, name: string, counter?: number }) => {
    const { currentTabPosition } = useContext(TabPositionContext);
    const current = currentTabPosition === link;

    return (
        <li className={"nav-item" + (current ? " active" : "")}>
            <Link to={getLinkTo(link)} className="nav-link" aria-current="page" >
                {counter ?
                    <>
                        <div className="link-content container-counter-tab ">
                            <p id='pCounter'>{name}</p>
                            <Counter counter={counter} />
                        </div>
                        <hr id='hrCounter' />
                    </>
                    :
                    <>
                        <p>{name}</p>
                        <hr />
                    </>
                }
            </Link>
        </li>
    )
};

const CompanyItem = ({ Id, Value }: { Id: string, Value: string }) => {
    return (
        <Link to={`/${TranslationService.currentLanguage}/switchcompany?to=${Id}`} className="changeCompany  mw-200">
            <div className="changeCompany__name">
                <h5>{Value}</h5>
                {false && CompanyService.getIsAdmin() &&
                    <p><span className="me-1">51</span>{TranslationService.translate.Users}</p>}
            </div>
        </Link>);
};

export const LayoutHeaderDropdownItem = ({ link, name }: { link: string, name: string }) =>
(<li><Link to={getLinkTo(link)} onClick={(e) => {
    if (link === "") {
        alert("not implemented");
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
}} className="dropdown-item">{name}</Link></li>);

const DropdownItem = LayoutHeaderDropdownItem;

export const LayoutHeaderDropdownTitle = (props: React.PropsWithChildren<unknown>) =>
    (<li><h6 className="dropdown-item">{props.children}</h6></li>);

const DropdownTitle = LayoutHeaderDropdownTitle;

export default LayoutHeader;